import { Component, Input } from '@angular/core';
import { Session } from 'app/shared/services/session/session.service';

@Component({
  selector: 'tog-left-nav-item',
  templateUrl: 'left-nav-item.template.html',
  styleUrls: ['left-nav-item.scss']
})
export class LeftNavItemComponent {
  @Input() feature: any;

  constructor(private _session: Session) {}
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/left-nav/left-nav-item.component.ts